




























































































































































































import { Component, Vue, Prop } from 'vue-property-decorator'
import RechargeCardApi from '@/api/marketing/rechargeCard/index'
import AbpBase from '@/lib/abpbase'
import PicModal from '@/components/upload/picModal.vue'
import CustomForm from '@/components/custom-form/index.vue'
import GoodsApi from '@/api/goods/list'
@Component({
  components: {
    PicModal,
    CustomForm,
  },
})
export default class RechargeCardProductEdit extends AbpBase {
  currentTab: string = 'basicForm'
  activityId: string = ''
  addrecharge: boolean = false
  isShowSelectProductModal: boolean = false
  automaticCardModal: boolean = false
  totalCount: number = 0
  pageSize: number = 10
  pageIndex: number = 1
  loading: boolean = false
  autoInputValue: number = null
  page: any = {
    totalCount: 0,
    currentPage: 1,
    pageSize: 10,
  }
  selectedProdcutColumns: any[] = [
    {
      title: '编号',
      key: 'code',
      align: 'center',
    },
    {
      title: '图片',
      slot: 'pictureUrl',
      align: 'center',
    },
    {
      title: '商品名称',
      key: 'productName',
      align: 'center',
    },
    {
      title: '数量',
      key: 'quantity',
      align: 'center',
      render: (h, params) => {
        return h('InputNumber', {
          props: {
            value: this.getProductList()[params.index].quantity,
            min: 1
          },
          on: {
            'on-change': (event) => {
              this.getProductList()[params.index].quantity = event
            }
          }
        })
      }
    },
    {
      title: '操作',
      slot: 'action',
      width: 150,
      align: 'center',
    },
  ]
  productFilters: any[] = [
    {
      label: '输入搜索：',
      type: 'input',
      props: {
        placeholder: '商品名称/商品货号',
      },
      key: 'keyWord',
    },
    {
      label: '商品分类：',
      type: 'select',
      key: 'categoryId',
      props: {
        placeholder: '请选择',
      },
      options: [],
    },
  ]
  productColumns: any[] = [
    {
      title: '#',
      tree: true,
      align: 'center',
      width: 60,
    },
    // {
    //   type: 'selection',
    //   width: 60,
    //   align: 'center',
    // },
    {
      title: '款号',
      key: 'code',
      align: 'center',
    },
    // {
    //   title: '商品标签',
    //   key: 'productTagMappings',
    //   align: 'center',
    // },
    {
      title: '商品图',
      width: 100,
      slot: 'pictureUrl',
      align: 'center',
    },
    {
      title: '商品名称',
      key: 'name',
      align: 'center',
    },
    {
      title: '操作',
      slot: 'action',
      align: 'center'
    }
  ]
  productData: any[] = []
  columns: any[] = [
    {
      title: '卡号',
      key: 'name',
      align: 'center',
    },
    {
      title: '密码',
      key: 'value',
      align: 'center',
    },
    {
      title: '操作',
      slot: 'action',
      width: 150,
      align: 'center',
    },
  ]
  addRechargeText: string = ''
  formItem = {
    name: '',
    code: '',
    beginTime: null,
    endTime: null,
    isPublish: false,
    items: [],
    rechargeableProducts: []
  }
  ruleValidate = {
    name: [{ required: true, message: '活动标题不能为空', trigger: 'blur' }],
    code: [{ required: true, message: '编码不能为空', trigger: 'blur' }],
    // amount: [{ required: true, message: '面额不能为空', trigger: 'blur' }],
    beginTime: [
      {
        required: true,
        validator: this.validBeginTime,
        trigger: 'change',
      },
    ],
    endTime: [
      {
        required: true,
        validator: this.validEndTime,
        trigger: 'change',
      },
    ],
  }
  // picChange(e) {
  //   console.log(e)
  //   this.formItem.imgUrl = e[0].url
  // }
  validBeginTime(rule, value, callback) {
    if (value == '' || !value) {
      callback(new Error('请选择开始日期'))
    } else {
      ;(this.$refs as any).basicForm.validateField('endTime')
    }
    callback()
  }
  deleteRecharge(index) {
    this.formItem.items.splice(index, 1)
  }
  validEndTime(rule, value, callback) {
    if (value === '' || !value) {
      callback(new Error('请选择结束日期'))
    }
    if (value < this.formItem.beginTime) {
      callback(new Error('结束日期必须大于开始日期'))
    }
    callback()
  }
  cancelFn() {
    this.addrecharge = false
    this.addRechargeText = ''
  }
  saveFn() {
    if (this.addRechargeText.trim() == '') {
      this.$Notice.warning({
        title: '卡密输入不能为空',
      })
      return
    }
    let arr = this.addRechargeText.split(/[(\r\n)\r\n]+/)
    let arr1 = []
    if (arr.length) {
      arr1 = arr.map((item) => {
        return {
          name: item.split(' ')[0],
          value: item.split(' ')[1],
        }
      })
    }
    console.log(arr1)
    this.formItem.items = this.removal(this.formItem.items.concat(arr1))
    this.addrecharge = false
    this.addRechargeText = ''
  }
  saveAutoFn() {
    if(!this.autoInputValue) {
      this.$Notice.warning({
        title: '生成的卡密条数不能为空'
      })
      return
    }
    RechargeCardApi.autoGenerate(this.autoInputValue).then(res => {
      console.log('自动卡密', res);
      this.$Notice.success({
        title: '生成成功'
      });
      this.automaticCardModal = false;
      this.autoInputValue = null;
      this.formItem.items = this.removal(this.formItem.items.concat(res.data.items))
    })
  }
  removal(arr) {
    for (let i = 0; i < arr.length; i++) {
      for (let j = i + 1; j < arr.length; j++) {
        if(arr[i].name == arr[j].name && arr[i].value == arr[j].value) {
          arr.splice(j, 1);
          j--;
        }        
      }
    }
    return arr
  }
  async onPageChange(pageIndex: number) {
    this.pageIndex = pageIndex
  }
  save() {
    var valid1 = (this.$refs['basicForm'] as any).validate()
    var valid2 =
      (this.$refs['ruleConfigForm'] as any).rules === null
        ? new Promise((resolver) => resolver(true))
        : (this.$refs['ruleConfigForm'] as any).validate();
    Promise.all([valid1, valid2]).then((values) => {
      let index = values.findIndex((x) => x === false)
      if (index > -1) {
        if (index === 0) this.currentTab = 'basicForm'
        if (index === 1) this.currentTab = 'ruleConfigForm'
      } else {
        if(!this.formItem.rechargeableProducts.length) {
          this.$Notice.warning({
            title: '商品不能为空'
          })
          this.currentTab = 'ruleConfigForm'
          return
        }
        if(!this.activityId && !this.formItem.items.length) {
          this.$Notice.warning({
            title: '卡密不能为空'
          })
          this.currentTab = 'ruleConfigForm'
          return
        }
        if (this.activityId) {
          RechargeCardApi.updateProductDetail(this.activityId, this.formItem).then((res) => {
            this.$Message.success('保存成功')
            this.$router.push({
              name: 'rechargeCardProduct',
            })
          })
        } else {
          console.log(this.formItem)
          RechargeCardApi.createChargeProductCard(this.formItem).then((res) => {
            this.$Message.success('保存成功')
            this.$router.push({
              name: 'rechargeCardProduct',
            })
          })
        }
      }
    })
  }
  created() {
    if (this.$route.query.id !== undefined) {
      this.activityId = this.$route.query.id.toString()
      this.loadActivity()
    }
  }
  loadActivity() {
    RechargeCardApi.getProductDetail(this.activityId).then((res) => {
      console.log('卡密活动', res)
      this.formItem = res.data
      this.formItem.beginTime = new Date(res.data.beginTime)
      this.formItem.endTime = new Date(res.data.endTime)
    })
  }
  // 下面是商品modal事件
  addProduct() {
    this.getCategoriesAll()
    this.getProductData()
    this.isShowSelectProductModal = true
  }
  onSubmit(form) {
    this.getProductData(form)
  }
  getProductList() {
    return this.formItem.rechargeableProducts
  }
  submitFn() {
    let form: any = this.$refs.lineForm
    form.submit()
  }
  deleteProduct(index) {
    console.log(index);
    this.formItem.rechargeableProducts.splice(index, 1)
  }
  getProductData(form = {}) {
    // this.isCheckAll = false
    let keyWord = form['keyWord']
    let categoryId = form['categoryId']
    let { pageSize, currentPage } = this.page
    this.loading = true
    GoodsApi.getList(pageSize, currentPage, keyWord, categoryId)
      .then((res) => {
        this.loading = false
        let { totalCount, items } = res.data
        if(res.data.items.length) {
          res.data.items.forEach(item => {
            item._showChildren = true
            if(item.productSKUs && item.productSKUs.length) {
              item.productSKUs.forEach(item1 => {
                item1.name = item1.attributeXml
                item1.isShowAction = true
                item1.productId = item.id
                item1.productName = item.name
                item1.quantity = 1
              })
            }
            item.children = item.productSKUs
          });
          console.log(res.data.items);
          this.page.totalCount = res.data.totalCount
          this.productData = res.data.items
        }
      })
      .catch(() => {
        this.loading = false
        this.page.totalCount = 0
        this.productData = []
      })
  }
  /**
   * 获取商品分类
   */
  getCategoriesAll() {
    GoodsApi.getCategoriesAll().then((res) => {
      if (res.data.items) {
        this.productFilters.some((item) => {
          if (item.label == '商品分类：') {
            item.options = res.data.items.map((child) => {
              return {
                value: child.id,
                text: child.fullName,
              }
            })
            return true
          }
        })
      }
    })
  }
  // 选择商品
  slectProduct(row) {
    console.log(row);
    let tempArr = this.formItem.rechargeableProducts
    let obj = {
      productId: row.productId,
      skuId: row.id,
      productName: row.productName,
      pictureUrl: row.pictureUrl,
      code: row.code,
      quantity: row.quantity
    }
    if(tempArr && tempArr.length) {
      let isHave = tempArr.find(item => item.skuId == row.id);
      if(JSON.stringify(isHave) != '{}') {
        this.formItem.rechargeableProducts.push(obj)
      }
    }else {
      this.formItem.rechargeableProducts.push(obj)
    }
    this.isShowSelectProductModal = false
  }
  // 选择完商品
  sureProduct() {}

  pageSizeChange(pageSize) {
    this.page.pageSize = pageSize
    this.page.currentPage = 1
    this.submitFn()
  }
  changePage(currentPage) {
    this.page.currentPage = currentPage
    this.submitFn()
  }
}
